// styles
import "./styles.scss";

import phoneIcon from "../../assets/images/icons/icon-phone.svg";
import locationIcon from "../../assets/images/icons/icon-location.svg";
import { socialLink } from "./utils";

function Footer() {
  return (
    <>
      <footer className="footer-sec-container">
        <div className="container">
          <div className="top-content">
            <div className="first-half">
              <div className="contact-info-box tel fx fx--ai-fs">
                <img className="icon phone" src={phoneIcon} alt="icon phone" />
                <div className="tel-no text-white">
                  <a href="tel:+6531658101" className="link text-white">
                    +6531658101
                  </a>
                </div>
              </div>
              <div className="contact-info-box address fx fx--ai-fs">
                <img
                  className="icon phone"
                  src={locationIcon}
                  alt="icon phone"
                />
                <div className="address text-white">
                  133, New Bridge Road,
                  <br /> #10-3, Chinatown Point, Singapore (059413)
                </div>
              </div>
            </div>
            <div className="second-half">
              <ul className="social-contact fx fx--ai-c pl--0">
                {socialLink.map((item) => {
                  return (
                    <li key={item?.altTag}>
                      <a
                        href={item.link}
                        target="_blank"
                        rel="noreferrer"
                        className="link"
                      >
                        <img
                          className="icon"
                          src={item.icon}
                          alt={item.altTag}
                        />
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
          <div className="bottom-content">
            {/* <div className="footer-link">
              <a href="#" className="link text-white">Terms & Conditions</a>
            </div> */}
            <div className="copyright-text text-white">
              © 2021. All Rights Reserved
            </div>
            {/* <div className="footer-link">
              <a href="#" className="link text-white">Privacy Policy</a>
            </div> */}
          </div>
        </div>
      </footer>
    </>
  );
}
export default Footer;
